import { isDarkTheme } from '#/common/utils/themeDetection';
import { color } from '@nuvolo/nuux-theme/utils';
import styled from 'styled-components';

interface StylesProps {
  $noBorder?: boolean;
  $noPadding?: boolean;
}

const Styles = styled.div<StylesProps>`
  ${({ theme }) => {
    if (isDarkTheme(theme)) {
      return `
        .MuiGrid-item .record-preview-label {
          color: ${color('primary', 'middle')} !important;
        }
        .MuiDivider-root {
          border: 1px solid ${color('ui', 'light')} !important;
        }
      `;
    }
    return `
      .MuiGrid-item .record-preview-label {
        color: ${color('primary', 'middle')} !important;
      }
      .MuiDivider-root {
        border: 1px solid ${color('primary', 'light')} !important;
      }
    `;
  }}
  .MuiGrid-container {
    width: auto;
    border: ${({ $noBorder }) => ($noBorder ? 'none' : `1px solid ${color('primary', 'light')}`)};
    border-radius: 24px;
    padding: ${({ $noPadding }) => ($noPadding ? '0' : '24px')};
    background-color: ${({ $noBorder }) =>
      $noBorder ? 'transparent' : color('custom', 'dataGridBackground')};
    margin: ${({ $noBorder }) => ($noBorder ? '0' : '16px 16px 16px 0')};
    position: relative;
  }
  .record-preview-title {
    left: 0;
    font-size: 20px;
    font-weight: 500;
    line-height: 26px;
    height: 26px;
    color: ${color('primary', 'dark')};
    padding: 0;
  }
  .MuiDivider-root {
    width: 100%;
    margin-bottom: 24px;
  }
  .MuiGrid-item {
    padding: 0;
    margin-bottom: 24px;
    .record-preview-text {
      font-size: 16px !important;
      color: ${color('primary', 'dark')};
    }
    &:last-child {
      margin-bottom: 0;
    }
    .record-preview-label {
      font-size: 14px !important;
    }
    .list-field-ul {
      padding-left: 20px;
    }
  }
`;

export default Styles;
